import { computed, defineComponent, onMounted, reactive } from 'vue';
import { useStore } from 'vuex';
import { MinisterAction, MinisterGetter } from '@/store/minister/minister.module';
import { Minister } from '@/store/minister/minister.model';
import LoadingComponent from '@/components/loading/Loading.vue';
import PaginateComponent from '@/components/paginate/Paginate.vue';

export default defineComponent({
  name: 'MinisterList',
  components: {
    LoadingComponent,
    PaginateComponent
  },
  emits: [
    'edit'
  ],
  setup: (_, context) => {
    const store = useStore();
    const ministers = computed<Minister[]>(() => store.getters[MinisterGetter.ALL]);
    const search = computed(() => ministers.value.filter((minister) => toSearch(minister)));
    const display = computed(() => search.value.filter((_, index) => toDisplay(index)));
    const isLoading = computed(() => store.getters[MinisterGetter.STATUS] === 'init' || store.getters[MinisterGetter.STATUS] === 'loading');

    const filter = reactive({
      keyword: '',
      amount: computed(() => search.value.length),
      total: computed(() => ministers.value.length)
    });

    const page = reactive({
      size: 6,
      current: 1
    });

    onMounted(() => {
      store.dispatch(MinisterAction.FETCH);
    });

    const toSearch = (minister: Minister): Minister | boolean => {
      return (filter.keyword)
        ? minister.fullName.toLowerCase().includes(filter.keyword.toLowerCase())
          ? minister
          : false
        : true;
    };

    const toDisplay = (index: number) => {
      const start = (page.current - 1) * page.size;
      const end = start + page.size;
      return index >= start && index < end;
    };

    const editClick = (id: number) => {
      context.emit('edit', id);
    };

    const selectedPage = (pageNumber: number) => {
      page.current = pageNumber;
    };

    return {
      isLoading,
      display,
      filter,
      page,
      editClick,
      selectedPage
    };
  }
});
